import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lesson", "progressBar", "completionText", "sidebar", "backdrop"]

  connect() {
    // Scroll current lesson into view
    this.scrollToCurrentLesson()

    // Listen for lesson completion events
    this.handleLessonCompleted = this.handleLessonCompleted.bind(this)
    this.handleProgressUpdated = this.handleProgressUpdated.bind(this)
    this.handleToggleSidebar = this.handleToggleSidebar.bind(this)

    window.addEventListener('segment-player:lessonCompleted', this.handleLessonCompleted)
    window.addEventListener('segment-player:progressUpdated', this.handleProgressUpdated)
    window.addEventListener('toggle-course-sidebar', this.handleToggleSidebar)
  }

  disconnect() {
    window.removeEventListener('segment-player:lessonCompleted', this.handleLessonCompleted)
    window.removeEventListener('segment-player:progressUpdated', this.handleProgressUpdated)
    window.removeEventListener('toggle-course-sidebar', this.handleToggleSidebar)
  }

  handleToggleSidebar() {
    this.toggleSidebar()
  }

  toggleSidebar() {
    if (this.hasSidebarTarget) {
      this.sidebarTarget.classList.toggle('translate-x-0')
      this.sidebarTarget.classList.toggle('translate-x-full')
    }
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.toggle('hidden')
    }
    // Prevent body scroll when sidebar is open on mobile
    document.body.classList.toggle('overflow-hidden')
  }

  closeSidebar() {
    if (this.hasSidebarTarget) {
      this.sidebarTarget.classList.remove('translate-x-0')
      this.sidebarTarget.classList.add('translate-x-full')
    }
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add('hidden')
    }
    document.body.classList.remove('overflow-hidden')
  }

  scrollToCurrentLesson() {
    const currentLesson = this.lessonTargets.find(lesson =>
      lesson.classList.contains('current-lesson')
    )

    if (currentLesson) {
      currentLesson.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  handleLessonCompleted(event) {
    const lessonId = event.detail.lessonId
    const lessonElement = this.lessonTargets.find(lesson =>
      parseInt(lesson.dataset.lessonId) === lessonId
    )

    if (lessonElement) {
      // Add checkmark icon
      const checkbox = lessonElement.querySelector('.lesson-checkbox')
      if (checkbox) {
        checkbox.innerHTML = `
          <svg class="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
          </svg>
        `
      }
    }
  }

  handleProgressUpdated(event) {
    const courseCompletion = event.detail.courseCompletion

    // Update progress bar
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${courseCompletion}%`
    }

    // Update completion text
    if (this.hasCompletionTextTarget) {
      this.completionTextTarget.textContent = `${Math.round(courseCompletion)}%`
    }
  }

  toggleChapter(event) {
    const chapterButton = event.currentTarget
    const chapterId = chapterButton.dataset.chapterId
    const lessonList = document.getElementById(`chapter-${chapterId}-lessons`)

    if (lessonList) {
      lessonList.classList.toggle('hidden')

      // Rotate chevron icon
      const chevron = chapterButton.querySelector('svg')
      if (chevron) {
        chevron.classList.toggle('rotate-180')
      }
    }
  }
}
